import { AnswerImage } from './answer-image';
import {AnswerMedia} from './answer-media';

export class Answers {
    zarca_q_id: number;
    value_id: number;
    value_text: string;
    ms_id: number;
    ParentMsId: number;
    IsNoneAbove: boolean;
    weight: number;
    isHide: boolean;
    IsHideNew: boolean;
    ControlAns: any;
    selectdId: number;

    CQ_QID: number;
    Rule_id: number;
    pageto: number;

    AnswerImages: AnswerImage[];
    AnswerMedias: AnswerMedia[];

    // ClientSide
    isOther: boolean = false;
    hasImage: boolean = false;
    hasMedia: boolean = false;
    isValid: boolean;
    isNA: boolean;

    isQuotaDisable: boolean;
    isQuotaHide:boolean;
    QuotaMessage : string;
    IsAnsPipe:boolean;
    isADLAnswer:boolean;
    isADLHide:boolean;
    adlCondStatus: ADLCondStatus[];
}

export class ADLCondStatus{
  rule_id:number;
  status : boolean;
}
